var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightSwich(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1101,
    height: 724,
    viewBox: "0 0 1101 724",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1082_26442)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 353,
    width: 15,
    height: 119,
    rx: 2,
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.2207,
    y: 325.232,
    width: 1.87259,
    height: 168,
    rx: 0.936297,
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 302,
    width: 15,
    height: 69,
    rx: 2,
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.4385,
    y: 290.181,
    width: 1.87259,
    height: 96,
    rx: 0.936297,
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 268,
    width: 15,
    height: 34,
    rx: 2,
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.6543,
    y: 262.122,
    width: 1.87259,
    height: 57,
    rx: 0.936297,
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344,
    y: 77.0001,
    width: 15,
    height: 173,
    rx: 2,
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.16,
    y: 64.2667,
    width: 1.87259,
    height: 209.73,
    rx: 0.936297,
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.9807,
    height: 16.8533,
    transform: "translate(474.626 185.986)",
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 43,
    width: 2,
    height: 231,
    rx: 1,
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.9807,
    height: 16.8533,
    transform: "translate(605.707 185.986)",
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 611.324,
    y: 64.2667,
    width: 1.87259,
    height: 209.73,
    rx: 0.936297,
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 742.407,
    y: 171.007,
    width: 1.87259,
    height: 209.73,
    rx: 0.936297,
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 304,
    width: 15,
    height: 39,
    rx: 2,
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.8701,
    y: 290.232,
    width: 1.87259,
    height: 68,
    rx: 0.936297,
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.9807,
    height: 140.444,
    transform: "translate(369.761 114.826)",
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.251,
    y: 103.591,
    width: 1.87259,
    height: 209.73,
    rx: 0.936297,
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.9807,
    height: 16.8533,
    transform: "translate(500.843 238.418)",
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 508.335,
    y: 103.591,
    width: 1.87259,
    height: 372.646,
    rx: 0.936297,
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.9807,
    height: 18.7259,
    transform: "translate(631.924 114.826)",
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 639.416,
    y: 103.591,
    width: 1.87259,
    height: 56.1778,
    rx: 0.936297,
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 196,
    width: 15,
    height: 85,
    rx: 2,
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.089,
    y: 178.378,
    width: 1.87259,
    height: 123,
    rx: 0.936297,
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134,
    y: 250,
    width: 15,
    height: 41,
    rx: 2,
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.304,
    y: 236.545,
    width: 1.87259,
    height: 65.5408,
    rx: 0.936297,
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 210,
    width: 15,
    height: 98,
    rx: 2,
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.386,
    y: 196.7,
    width: 1.87259,
    height: 146,
    rx: 0.936297,
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.9807,
    height: 20.5985,
    transform: "translate(395.979 238.419)",
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.469,
    y: 116.7,
    width: 1.87259,
    height: 209.73,
    rx: 0.936297,
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.9807,
    height: 13.1082,
    transform: "translate(527.058 395.717)",
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 534.548,
    y: 352.647,
    width: 1.87259,
    height: 67.4134,
    rx: 0.936297,
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.9807,
    height: 20.5985,
    transform: "translate(658.138 345.157)",
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 665.628,
    y: 223.437,
    width: 1.87259,
    height: 209.73,
    rx: 0.936297,
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 265,
    width: 15,
    height: 20,
    rx: 2,
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.521,
    y: 255.271,
    width: 1.87259,
    height: 37.4519,
    rx: 0.936297,
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 237,
    width: 15,
    height: 76,
    rx: 2,
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 227,
    width: 1.87,
    height: 109,
    rx: 0.935,
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291,
    y: 126,
    width: 15,
    height: 129,
    rx: 2,
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.731,
    y: 116.7,
    width: 1.87259,
    height: 163,
    rx: 0.936297,
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.9807,
    height: 16.8533,
    transform: "translate(422.194 238.419)",
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 427.812,
    y: 116.7,
    width: 1.87259,
    height: 191.005,
    rx: 0.936297,
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.2356,
    height: 12.64,
    transform: "translate(557.022 320.343)",
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560.767,
    y: 292.724,
    width: 1.87259,
    height: 80.5215,
    rx: 0.936297,
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.9807,
    height: 16.8533,
    transform: "translate(684.357 345.157)",
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 689.975,
    y: 223.437,
    width: 1.87259,
    height: 191.005,
    rx: 0.936297,
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.327,
    y: 238.419,
    width: 14.9807,
    height: 56.1778,
    rx: 2,
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.945,
    y: 226.7,
    width: 1.87259,
    height: 80,
    rx: 0.936297,
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.9807,
    height: 56.1778,
    transform: "translate(448.41 238.419)",
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 454.027,
    y: 116.7,
    width: 1.87259,
    height: 191.005,
    rx: 0.936297,
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.9807,
    height: 56.1778,
    transform: "translate(579.492 238.419)",
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 585.11,
    y: 238.419,
    width: 1.87259,
    height: 69.2859,
    rx: 0.936297,
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.9807,
    height: 56.1778,
    transform: "translate(710.572 259.016)",
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 718.062,
    y: 223.437,
    width: 1.87259,
    height: 191.005,
    rx: 0.936297,
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 334,
    width: 15,
    height: 80,
    rx: 2,
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 298,
    width: 2,
    height: 139,
    rx: 1,
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239,
    y: 268,
    width: 15,
    height: 112,
    rx: 2,
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.169,
    y: 250.966,
    width: 1.87259,
    height: 150,
    rx: 0.936297,
    fill: "#FE3D31"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1082_26442"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1101,
    height: 724,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightSwich);
export default __webpack_public_path__ + "static/media/right-swich.748c94c21a59b404badb84468eb7fe1d.svg";
export { ForwardRef as ReactComponent };